import { CurrencyLocation, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '../../filters/currency/currency-formatter.const';
import { CurrencyOptions } from '../currency.interfaces';

export const GBP: CurrencyOptions = {
  currencyLocation: CurrencyLocation.PREPEND,
  currencySpacing: false,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.DOT,
  currencySymbol: '£',
  hideDecimalsIfZero: false,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
